export const GEOHUB_PROTOCOL: string = 'https';
export const GEOHUB_SAVING_TRY_INTERVAL: number = 1000 * 60 * 5;
export const GEOHUB_DOMAIN: string = 'geohub.webmapp.it';
export const GEOHUB_TILES_DOMAIN: string =
  'https://webmapp-mbtiles.s3.eu-central-1.amazonaws.com';
export const TILES_DOMAIN: string = 'https://api.webmapp.it/tiles/';
export const GEOHUB_LOGIN_ENDPOINT: string = '/api/auth/login';
export const GEOHUB_REGISTER_ENDPOINT: string = '/api/auth/signup';
export const GEOHUB_LOGOUT_ENDPOINT: string = '/api/auth/logout';
